import { render, staticRenderFns } from "./VehicleCard.vue?vue&type=template&id=4750f2b8&"
import script from "./VehicleCard.vue?vue&type=script&lang=js&"
export * from "./VehicleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports